var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("myEcharts", {
    directives: [
      {
        name: "loading",
        rawName: "v-loading",
        value: _vm.loading,
        expression: "loading",
      },
    ],
    attrs: {
      isShowEmpty: _vm.isShowEmpty,
      option: _vm.option,
      field: _vm.field,
      designer: _vm.designer,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }